import { useEffect } from 'react'

export default ({ children }) => {
  useEffect(() => {
    document.body.classList.add('_recaptcha')

    return () => {
      document.body.classList.remove('_recaptcha')
    }
  }, [])

  return children
}
